<template><svg width="30" height="30" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30">
  <path d="M2 2h25v25h-8V10h-9v17H2V2z" fill="currentColor" />
</svg>
</template>